import type { LoaderFunctionArgs } from '@remix-run/node'
import { Outlet, useLoaderData, useLocation } from '@remix-run/react'
import { MyPersonalData } from '~/design-system/components'
import { cartLoader } from '~/loaders/cart'

export const handle = {
  breadcrumb: 'Meus Dados',
}

export const loader = async (context: LoaderFunctionArgs) =>
  cartLoader({ ...context, currentStage: 'myaccount' })

export default function DadosCadastrais() {
  const location = useLocation()
  useLoaderData<typeof loader>()

  if (location.pathname.includes('/editar')) {
    return <Outlet />
  }

  return <MyPersonalData />
}
